<template>
  <v-container>
    <v-card elevation="0">
      <v-card-title>Opciones de herramientas
        <v-spacer></v-spacer>
        <v-btn text color="primary" @click="processTools">procesar herramientas</v-btn>
      </v-card-title>
      <v-card-text>
        <v-row v-if="loadingData">
          <v-col class="d-flex justify-center">
            <v-progress-circular color="primary" indeterminate width="2" size="60" />
          </v-col>
        </v-row>
        <v-row v-if="loadedData">
          <v-col>
            <v-card outlined>
              <v-card-title>
                <v-icon class="mr-2">mdi-wrench-clock</v-icon>
                Herramientas asignadas ({{ toolsAssigned.length }})
                <v-spacer />
                <v-btn icon @click="showListAssigned = !showListAssigned">
                  <v-icon>
                    {{ showListAssigned ? "mdi-chevron-up" : "mdi-chevron-down" }}
                  </v-icon>
                </v-btn>
              </v-card-title>
              <v-expand-transition>
                <div v-show="showListAssigned">
                  <v-card-text>
                    <v-list>
                      <template v-for="(tool, key) in toolsAssigned">
                        <v-list-item :key="key" v-if="toolsAssigned" @click="releaseTool(tool)">
                          <v-list-item-content>
                            <v-list-item-title>
                              <b>
                                {{ tool.name }}
                              </b>
                            </v-list-item-title>
                            <v-list-item-subtitle>{{ tool.description }}</v-list-item-subtitle>
                          </v-list-item-content>
                        </v-list-item>
                        <v-divider :key="`div${key}`" v-if="key != toolsAssigned.length - 1" />
                      </template>
                    </v-list>
                  </v-card-text>
                </div>
              </v-expand-transition>
            </v-card>

            <v-card outlined class="mt-5">
              <v-card-title>
                <v-icon class="mr-2">mdi-tools</v-icon>
                Herramientas disponibles ({{ toolsAvailable.length }})
                <v-spacer />
                <v-btn icon @click="showListAvailable = !showListAvailable">
                  <v-icon>
                    {{ showListAvailable ? "mdi-chevron-up" : "mdi-chevron-down" }}
                  </v-icon>
                </v-btn>
              </v-card-title>
              <v-expand-transition>
                <div v-show="showListAvailable">
                  <v-card-text>
                    <v-text-field v-model="search" append-icon="mdi-magnify" label="Buscar herramienta" single-line
                      hide-details style="max-width: 400px" class="mb-5"></v-text-field>

                    <v-data-table :search="search" :headers="headers" :items="toolsAvailable" :items-per-page="10"
                      :mobile-breakpoint="800" @click:row="assingTool">
                      <template v-slot:[`item.name`]="{ item }">
                        {{ item.name }}
                      </template>

                    </v-data-table>
                  </v-card-text>
                </div>
              </v-expand-transition>
            </v-card>
          </v-col>
        </v-row>
      </v-card-text>
    </v-card>
  </v-container>
</template>

<script>
export default {
  props: ["click", "employeeId", "schema"],

  mounted() {
    this.loadTools();
  },

  data() {
    return {
      loadingData: true,
      loadedData: false,
      showListAssigned: false,
      showListAvailable: false,
      tools: [],
      search: "",
      headers: [
        {
          text: "Nombre",
          value: "name",
          width: "30%",
        },
        {
          text: "Ubicacion",
          value: "location.name",
          width: "30%",
        },
        {
          text: "Descripcion",
          aling: "left",
          value: "description",
          width: "40%",
        },
      ],
    };
  },

  watch: {
    click() {
      this.showListAvailable = false;
      this.showListAssigned = false;
      this.loadTools();
    },
  },

  computed: {
    toolsAssigned() {
      if (this.tools.length) {
        let toolsAssigned = [];
        this.tools.forEach(element => {
          if (this.schema == "edit") {
            if (element.employee_id == -1) {
              toolsAssigned.push(element);
            } else if (element.employee_id == this.employeeId) {
              toolsAssigned.push(element);
            }
          } else {
            if (element.employee_id == -1)
              toolsAssigned.push(element)
          }
        });
        return toolsAssigned;
      }
      return [];
    },

    toolsAvailable() {
      if (this.tools.length) {
        let va = this.tools.filter((v) => v.employee_id == 0);
        return va;
      }
      return [];
    },
  },

  methods: {
    loadTools() {
      this.loadingData = true;
      this.loadedData = false;
      this.toolIds = "";

      setTimeout(() => {
        this.$store.dispatch("findToolsAction").then((res) => {
          this.tools = res;

          this.loadingData = false;
          this.loadedData = true;
        });
      }, 500);
    },

    assingTool(value) {
      let index = this.tools.findIndex((v) => v.id == value.id);
      this.tools[index].employee_id = -1;
    },

    releaseTool(value) {
      let index = this.tools.findIndex((v) => v.id == value.id);
      this.tools[index].employee_id = 0;
    },

    processTools() {
      let toolIds = "";

      this.toolsAssigned.forEach((element) => {
        toolIds += element.id + ",";
      });

      toolIds += "0";

      this.$emit("toolsIds", toolIds);
    },
  },
};
</script>
